<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog :value="displayBpSelectionDialog" max-width="400" persistent>
    <v-card>
      <v-card-title>
        {{ $t('selectBps') }}
      </v-card-title>

      <v-card-text>
        <v-checkbox
          v-for="bp in availableBusinessProcesses"
          :key="bp.value"
          :input-value="checkedBusinessProcesses.includes(bp.value)"
          :label="bp.label"
          hide-details
          @change="value => onBpSelection(value, bp.value)"
        ></v-checkbox>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="onDialogClose">
          {{ $t('close') }}
        </v-btn>
        <v-btn color="primary" :disabled="checkedBusinessProcesses.length == 0" text @click="onDialogAccept">
          {{ $t('accept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'EcsThemeMultipleBps',
  data() {
    return {
      checkedBusinessProcesses: []
    };
  },
  watch: {
    displayBpSelectionDialog(newValue) {
      if (newValue) {
        this.checkedBusinessProcesses = this.selectedBusinessProcesses;
      }
    }
  },
  computed: {
    ...mapGetters(['businessProcesses', 'selectedBusinessProcesses', 'displayBpSelectionDialog']),
    availableBusinessProcesses() {
      return this.businessProcesses.map(bp => {
        return {
          label: bp.name,
          value: bp.endPoint
        };
      });
    }
  },
  methods: {
    ...mapActions(['toggleBpSelectionDialog', 'setSelectedBusinessProcesses', 'toggleOverrideThemeForBpsDialog']),
    onBpSelection(value, bpEndPoint) {
      if (value) {
        this.checkedBusinessProcesses.push(bpEndPoint);
      } else {
        this.checkedBusinessProcesses = this.checkedBusinessProcesses.filter(bp => bp !== bpEndPoint);
      }
    },
    onDialogClose() {
      this.toggleBpSelectionDialog();
    },
    onDialogAccept() {
      this.setSelectedBusinessProcesses(this.checkedBusinessProcesses);
      this.toggleBpSelectionDialog();
      this.toggleOverrideThemeForBpsDialog();
    }
  }
};
</script>

<style></style>
